import Layout from '@/pages/Layout';

export default [
    {
        path: '/customer',
        redirect: 'noredirect',
        component: Layout,
        name: 'customer',
        meta: {
            title: '客服中心',
            icon: 'el-icon-user'
        },
        children: [
            {
                path: 'companyAuth',
                component: () => import('@/pages/customer/CompanyAuth'),
                name: 'companyAuth',
                meta: {
                    title: '企业审核',
                    icon: 'beer'
                }
            },
            {
                path: 'systemConfig',
                component: () => import('@/pages/customer/SystemConfig'),
                name: 'systemConfig',
                meta: {
                    title: '系统管理',
                    icon: 'beer'
                }
            },
            {
                path: 'digitalView',
                component: () => import('@/pages/customer/DigitalView'),
                name: 'digitalView',
                meta: {
                    title: '数字化视图',
                    icon: 'beer'
                }
            },
            {
                path: 'customer-application',
                component: () => import('@/pages/customer/CustomerApplication'),
                name: 'customer-application',
                meta: {
                    title: '应用方案管理',
                    icon: 'beer'
                }
            },
            {
                path: 'appCopyRecord',
                component: () => import('@/pages/customer/AppCopyRecord'),
                name: 'appCopyRecord',
                meta: {
                    title: '应用复制记录',
                    icon: 'beer'
                }
            },
            {
                path: 'componentCopyRecordList',
                component: () => import('@/pages/customer/ComponentCopyRecordList'),
                name: 'componentCopyRecordList',
                meta: {
                    title: '组件复制记录',
                    icon: 'beer'
                }
            },
            {
                path: 'bcbpmProcessList',
                component: () => import('@/pages/customer/BcbpmProcessList'),
                name: 'bcbpmProcessList',
                meta: {
                    title: '流程实例列表',
                    icon: 'beer'
                }
            },
            {
                path: 'loginInfoList',
                component: () => import('@/pages/customer/LoginInfoList'),
                name: 'loginInfoList',
                meta: {
                    title: '登录统计列表',
                    icon: 'beer'
                }
            },
            {
                path: 'customer-messageTemplate-list',
                component: () => import('@/pages/customer/CustomerMessage/MessageTemplateList'),
                name: 'messageTemplateList',
                meta: {
                    title: '消息模板管理',
                    icon: 'beer'
                }
            },
            {
                path: 'customer-messageTemplate-add',
                component: () => import('@/pages/customer/CustomerMessage/MessageTemplateDetail'),
                isShow: false,
                name: 'messageTemplateAdd',
                meta: {
                    title: '添加消息模板',
                    icon: 'beer'
                }
            },
            {
                path: 'dataHoldAll',
                component: () => import('@/pages/customer/DataHoldAll/DataHoldAll'),
                name: 'dataHoldAll',
                meta: {
                    title: '数据工具箱',
                    icon: 'beer'
                }
            },
            {
                path: 'apiConfig',
                component: () => import('@/pages/customer/ApiConfig/ApiConfig'),
                name: 'apiConfig',
                meta: {
                    title: 'api配置',
                    icon: 'beer'
                }
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-customer.js